export class FilterSwitch {
    constructor() {
        $('#msFrontBtnToggleUltrasearchFormFilters').on('click',function () {
            $('[data-filter-toggle-hide]').toggleClass('d-none')
            $('.catalog-filter').toggleClass('d-none');
            $('[data-filter-toggle-show]').toggleClass('d-none')
        })
    }
}